import RailsResource from './rails-resource';

class LeadService extends RailsResource {
  constructor() {
    super({
      url: '/admin',
      resource: 'leads',
      ajaxLoader: false
    });
  }
}

export default new LeadService();
